export default __webpack_public_path__ + "static/media/acko.ea64b151.png";